import DataManager from '@/assets/DataManager.js'

const DataFunctions = new function() {
  this.tagList = false;
  this.menuList = false;

  this.getTagListData = function() {
    return new Promise((resolve) => {
      if(this.tagList == false) {
        DataManager.getData([
      			DataManager.tagList
      		], (response) => {
      		this.tagList = response[0].data;
          resolve();
      	});
      }
      else {
        resolve();
      }
    });
  };

  this.getMenuListData = function() {
    return new Promise((resolve) => {
      if(this.menuList == false) {
        DataManager.getData([
            DataManager.menuList
      		], (response) => {
      		this.menuList = response[0].data;
          resolve();
      	});
      }
      else {
        resolve();
      }
    });
  };

  this.findPrimaryTag = function(feature) {
    return new Promise((resolve) => {
      this.getTagListData().then(() => {
        var tagId;
        feature.tags.forEach(function(obj) {
          if(obj.primary == true) {
            tagId = obj.id;
          }
        });

        if(tagId == undefined) {
          tagId = feature.tags[0].id;
        }

        for(var i in this.tagList) {
          if(this.tagList[i].id == tagId) {
            resolve(this.tagList[i]);
          }
        }
      });
    });
  };

  this.findNonPrimaryTags = function(feature) {
  	var listOfTags = {};

  	feature.tags.forEach(function(obj, index) {
  		if(obj.primary != true) {
  			listOfTags[index] = {'name': obj.name, 'id': obj.id};
  		}
  	});

  	return listOfTags;
  };

  this.getFeatureById = function(tagId, placeId) {
    return new Promise((resolve) => {
      DataManager.getData([
          DataManager.newTags+tagId+'-dk-light.json',
        ], (response) => {
        var data = response[0].data;
        //var feature = data.features.filter(feature => feature.id == placeId);
        let result = data.features.find(feature => feature.id == placeId);
        resolve(result);
      });
    });
  };

  this.getTagById = function(tagId) {
    return new Promise((resolve) => {
      this.getTagListData().then(() => {
        for(var i in this.tagList) {
          if(this.tagList[i].id == tagId) {
            resolve(this.tagList[i]);
          }
        }
      });
    });
  };

  this.getGroupById = function(id) {
    return new Promise((resolve) => {
      this.getMenuListData().then(() => {
        for(var i in this.menuList) {
          if(this.menuList[i].id == id) {
            resolve(this.menuList[i]);
          }
          else {
            for(var a in this.menuList[i].children) {
              if(id == this.menuList[i].children[a].id) {
                resolve(this.menuList[i].children[a]);
              }
            }
          }
        }
      });
    });
  };
};

export default DataFunctions;
